import { Injectable } from '@angular/core';
import { DateRangeInterval } from '@app/core/components/date-range/date-range.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class PictureService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 896
     * @datataskName sp_ws_p2_w_pictures_get
     * @param params
     * @returns promise containing page get for the pictures page.
     */
    public async getPictures(params: GetPicturesParams): Promise<PicturesGet> {
        return (await this.datatask.Post(896, params))[0];
    }
}

export interface GetPicturesParams {
    argtype: string;
    argvalue: string;
}

export interface PicturesGet {
    page_heading: string;
    argtype: string;
    argvalue: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    show_setting: '1' | '0';
    show_dateselector: '1' | '0';
    total: `${number}`;
    pagesize: `${number}`;
    pageindex: `${number}`;
    view: 'grid' | 'list';
}
